import { render, staticRenderFns } from "./CITY-HistoricalData-Stacked.vue?vue&type=template&id=f0996188&"
import script from "./CITY-HistoricalData-Stacked.vue?vue&type=script&lang=js&"
export * from "./CITY-HistoricalData-Stacked.vue?vue&type=script&lang=js&"
import style0 from "./CITY-HistoricalData-Stacked.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports